import React from 'react';
import ReactDOM from 'react-dom';

// Imported UI Library CSS 
import 'antd/lib/drawer/style/index.css';
import 'antd/lib/grid/style/index.css'
import 'antd/lib/badge/style/index.css'
import "react-datepicker/dist/react-datepicker.css";
import 'semantic-ui-css/semantic.min.css'

import './index.scss';

import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
